import styled from "styled-components";
import { SwiperGamesListDefaultBox } from "./swiper-games-list.default.box";

export const SwiperGamesListSICisBox = styled(SwiperGamesListDefaultBox)`
    background: ${props => props.theme.colors.backgroundLight};
    margin-top: 0;
    padding-bottom: 1.2rem;
    box-shadow: 0px 0px 8px #00000059;
`;